const data = [
    {
        num: "1",
        mintColor: "white",
        text: "Connect Your Wallet"
    },
    {
        num: "2",
        mintColor: "white",
        text: "Confirm the Transaction"
    },
    {
        num: "3",
        mintColor: "white",
        text: "Receive Your NFT"
    },
    {
        num: "4",
        mintColor: "white",
        text: "Enjoy Your NFT"
    },
]

export default data;